import React from 'react'
import Link from 'gatsby-link'

const Header = ({ siteTitle, titleLink }) => (
  <div
    style={{
      background: 'powderblue',
      marginBottom: '1.45rem',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '1.45rem 1.0875rem',
      }}
    >
      <h1 style={{ margin: 0 }}>
        <a href={titleLink} target="_blank"
          style={{
            color: 'white',
            textDecoration: 'none',
          }}>
          {siteTitle}
        </a>
      </h1>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js